import { _ as _sfc_main } from "./VaMessageListWrapper.vue_vue_type_script_lang-67f496f5.mjs";
import { resolveComponent, openBlock, createElementBlock, renderSlot, createVNode } from "vue";
import { _ as _export_sfc } from "../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaMessageListWrapper_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-message-list-wrapper" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_message_list = resolveComponent("va-message-list");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    renderSlot(_ctx.$slots, "default"),
    createVNode(_component_va_message_list, {
      color: _ctx.messagesColor,
      limit: _ctx.errorLimit,
      "has-error": _ctx.hasError,
      "model-value": _ctx.messagesComputed
    }, null, 8, ["color", "limit", "has-error", "model-value"])
  ]);
}
const VaMessageListWrapper = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  VaMessageListWrapper as V
};
//# sourceMappingURL=VaMessageListWrapper-a1b73765.mjs.map
